import { TbLink } from '@website-builder/model/domain/link/tb-link';
import { makeEntityId } from '@website-builder/util/make-widget-id.utility';
import { EntityIdPrefix } from '@website-builder/model/domain/entity-id-prefix.enum';

export class MenuElement {
  readonly type: 'list' | 'logo' | 'social';
  id = makeEntityId(EntityIdPrefix.WIDGET_ELEMENT);
  title: string;
  items: MenuElement[] = [];
  logo: string;
  icon: string;
  link = new TbLink();

  constructor(type: 'list' | 'logo' | 'social') {
    this.type = type;
    if (type === 'logo') {
      this.title = 'Logo';
      this.logo = 'assets/images/builder/placeholders/cityscape.png';
    } else if (type === 'social') {
      this.title = 'Social';
      this.icon = 'mdi:facebook';
    } else {
      this.title = 'New Item';
    }
  }
}
